module.exports = __webpack_public_path__ + "img/operate_list4.6c5b055a.png";